import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';

import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';

import { AlertModule } from '../alert/alert.module';

import { AdyenCustomCardComponent } from './adyen-custom-card.component';
import { MatRadioModule } from '@angular/material/radio';
import { AdyenService } from '../../services/adyen.service';
import { LoadingModule } from '../loading/loading.module';


@NgModule({
    imports: [

        CommonModule,
        
        FormsModule,
        ReactiveFormsModule,
        NgxMaskDirective,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatProgressSpinnerModule,
        MatSelectModule,
        MatTabsModule,
        MatTooltipModule,
        AlertModule,
        MatRadioModule,
        
        LoadingModule

    ],
  exports: [
    AdyenCustomCardComponent
  ],
  providers: [
    AdyenService,
    provideNgxMask()
  ],
  declarations: [
    AdyenCustomCardComponent
  ]
})
export class AdyenCustomCardModule { }
